import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/plans/index.js");
